import { Subscription } from '@models/subscription.model';
import { Icon, useTranslation, Button } from '@testsigma/atoms';
import React from 'react';

interface UsageHeaderPros {
  subscription: Subscription;
  refresh: () => void;
  isRefreshing: boolean;
  close: () => void;
}

export const UsageHeader: React.FC<UsageHeaderPros> = ({
  subscription,
  refresh,
  isRefreshing,
  close,
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex items-center'>
      <div className='text-lg text-unique-600 font-medium'>
        {t('usage_details.title')}
      </div>
      <Button type='light' onClick={refresh} isDisabled={isRefreshing} className='mx-3 hover:bg-secondary-50 !text-2xs'>
        <Icon name='refresh'
          className={
            isRefreshing && 'animate-spin'
          }
        />
        <span className='pl-1'> {t('usage_details.refresh')} </span>
      </Button>
      {Boolean(!subscription?.canShowRemainingMinutes) && (
        <div className='text-2xs'>
          {t('usage_details.remain_time', {
            RemainingMins:
              subscription?.remainingMinutes > 0
                ? subscription?.remainingMinutes
                : 0,
            TotalMins: subscription?.totalMinutes,
          })}
        </div>
      )}
      <div className='flex flex-grow justify-end items-center'>
        <Icon
          className='text-lg cursor-pointer'
          toolTip={t('common.close')}
          name='close'
          onClick={close}
        />
      </div>
    </div>
  );
};
